var _mask, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgChromeIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  fill: "none"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "chromeIcon_svg__a",
  width: 30,
  height: 30,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#chromeIcon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#DB4437",
  d: "M2.381 0v18.41h6.714L15 8.181h15V0H2.381Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__b)",
  d: "M2.381 0v18.41h6.714L15 8.181h15V0H2.381Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.15,
  d: "M9.257 18.35 2.468 6.706l-.099.17 6.74 11.557.148-.083Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#0F9D58",
  d: "M0 30h14.279l6.627-6.628V18.41H9.096L0 2.809v27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__c)",
  d: "M0 30h14.279l6.627-6.628V18.41H9.096L0 2.809v27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#263238",
  fillOpacity: 0.15,
  d: "m20.768 18.636-.141-.082L14.083 30h.196l6.494-11.36-.005-.005Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD40",
  d: "m15 8.182 5.906 10.227-6.627 11.59H30V8.183H15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__d)",
  d: "m15 8.182 5.906 10.227-6.627 11.59H30V8.183H15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFCD40",
  d: "m15 8.182 5.906 10.227-6.627 11.59H30V8.183H15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__e)",
  d: "m15 8.182 5.906 10.227-6.627 11.59H30V8.183H15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#DB4437",
  d: "M2.381 0v18.41h6.714L15 8.181h15V0H2.381Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__f)",
  d: "M2.381 0v18.41h6.714L15 8.181h15V0H2.381Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__g)",
  d: "M15 8.182v3.57l13.364-3.57H15Z"
}), /*#__PURE__*/React.createElement("mask", {
  id: "chromeIcon_svg__i",
  width: 7,
  height: 14,
  x: 14,
  y: 16,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__h)",
  d: "m14.29 29.98 3.572-13.329 3.044 1.758L14.29 29.98Z"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#chromeIcon_svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#0F9D58",
  d: "M0 30h14.279l6.627-6.628V18.41H9.096L0 2.809v27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__j)",
  d: "M0 30h14.279l6.627-6.628V18.41H9.096L0 2.809v27.19Z"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#0F9D58",
  d: "M0 30h14.279l4.13-7.245 2.497-4.346H9.096L0 2.809v27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__k)",
  d: "M0 30h14.279l3.96-6.904 2.667-4.687H9.096L0 2.809v27.19Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__l)",
  d: "m2.381 6.895 9.759 9.756-3.045 1.758L2.381 6.895Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__m)",
  d: "m14.29 29.98 3.572-13.329 3.044 1.758L14.29 29.98Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F1F1F1",
  d: "M15 21.818a6.818 6.818 0 1 0 0-13.636 6.818 6.818 0 0 0 0 13.636Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#4285F4",
  d: "M15 20.454a5.454 5.454 0 1 0 0-10.909 5.454 5.454 0 0 0 0 10.909Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.2,
  d: "M15 8.012a6.819 6.819 0 0 0-6.818 6.818V15A6.819 6.819 0 0 1 15 8.182h15v-.17H15Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.1,
  d: "M20.898 18.409A6.812 6.812 0 0 1 15 21.818a6.812 6.812 0 0 1-5.9-3.41h-.006L0 2.809v.171l9.095 15.6h.007a6.812 6.812 0 0 0 5.9 3.41 6.808 6.808 0 0 0 5.897-3.41h.009v-.17h-.01Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  d: "M15.17 8.182c-.028 0-.056.003-.085.005A6.815 6.815 0 0 1 21.818 15a6.815 6.815 0 0 1-6.733 6.813c.03 0 .056.005.085.005a6.818 6.818 0 0 0 0-13.636Z",
  opacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M20.966 18.635a6.798 6.798 0 0 0 .597-5.463A6.82 6.82 0 0 1 21.817 15c0 1.24-.336 2.4-.915 3.402l.003.007L14.28 30h.198l6.492-11.358-.003-.007Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillOpacity: 0.2,
  d: "M15 .17c8.255 0 14.952 6.67 14.998 14.915L30 15c0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15l.002.085C.048 6.84 6.745.17 15 .17Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#3E2723",
  fillOpacity: 0.15,
  d: "M15 29.83c8.255 0 14.952-6.67 14.998-14.915L30 15c0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15l.002-.085C.048 23.16 6.745 29.83 15 29.83Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "url(#chromeIcon_svg__n)",
  d: "M15 30c8.284 0 15-6.716 15-15 0-8.284-6.716-15-15-15C6.716 0 0 6.716 0 15c0 8.284 6.716 15 15 15Z"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__b",
  x1: 3.637,
  x2: 12.586,
  y1: 11.424,
  y2: 6.197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A52714",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#A52714",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__c",
  x1: 17.535,
  x2: 7.592,
  y1: 26.676,
  y2: 20.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__d",
  x1: 19.408,
  x2: 21.912,
  y1: 7.125,
  y2: 18.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA6100",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EA6100",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__e",
  x1: 19.408,
  x2: 21.912,
  y1: 7.125,
  y2: 18.09,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#EA6100",
  stopOpacity: 0.3
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#EA6100",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__f",
  x1: 3.637,
  x2: 12.586,
  y1: 11.424,
  y2: 6.197,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#A52714",
  stopOpacity: 0.6
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.66,
  stopColor: "#A52714",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__j",
  x1: 17.535,
  x2: 7.592,
  y1: 26.676,
  y2: 20.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "chromeIcon_svg__k",
  x1: 17.535,
  x2: 7.592,
  y1: 26.676,
  y2: 20.851,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#055524",
  stopOpacity: 0.4
}), /*#__PURE__*/React.createElement("stop", {
  offset: 0.33,
  stopColor: "#055524",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "chromeIcon_svg__g",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(14.349 8.173) scale(14.3315)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "chromeIcon_svg__h",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(14.973 15.023) scale(14.9778)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#263238",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#263238",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "chromeIcon_svg__l",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(2.366 6.906) scale(13.303)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3E2723",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#3E2723",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "chromeIcon_svg__m",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(14.973 15.023) scale(14.9778)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#263238",
  stopOpacity: 0.2
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#263238",
  stopOpacity: 0
})), /*#__PURE__*/React.createElement("radialGradient", {
  id: "chromeIcon_svg__n",
  cx: 0,
  cy: 0,
  r: 1,
  gradientTransform: "translate(4.48 4.093) scale(30.1278)",
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0.1
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#fff",
  stopOpacity: 0
})))));
export { SvgChromeIcon as ReactComponent };
export default "data:image/svg+xml;base64,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";